import { setQueryString, getQueryString } from '@/utils/UrlUtils';

const INITIAL_STATE = {
  currentPage: 1,
  updateRebateTier: null,
  ref: {
    canUpdate: '',
    composition: '',
    currentTier: '',
    rebateTierOptions: '',
  },
  premiumInformation: '',
};

export default {
  namespaced: true,

  state: { ...INITIAL_STATE },

  mutations: {
    resetState(state) {
      Object.assign(state, INITIAL_STATE);
    },

    updateFeature(state, data) {
      state.updateRebateTier = data;
    },

    updateCurrentPage(state, data) {
      state.currentPage = data;

      if (Number(getQueryString('step')) !== Number(data)) {
        setQueryString('step', data);
      }
    },

    updateRefRebateTierOptions(state, data) {
      state.ref.rebateTierOptions = data;
    },

    updateRefCanUpdate(state, data) {
      state.ref.canUpdate = data;
    },

    updateRefCurrentTier(state, data) {
      state.ref.currentTier = data;
    },

    updateRefComposition(state, data) {
      state.ref.composition = data;
    },
  },

  getters: {
    getCurrentPage: (state) => {
      return state.currentPage;
    },

    getUpdateRebateTier: (state) => {
      return state.updateRebateTier;
    },

    getRefData: (state) => {
      return state.ref;
    },
  },
};
